import { groupBy } from 'lodash';

import accountsResource from 'src/actions/accounts/accountsResource';
import channelsConfigurationResource from 'src/actions/channels/channelsConfigurationResource';
import communicationQueuesResource from 'src/actions/communicationQueues/communicationQueuesResource';
import endpointsResource, { Endpoint } from 'src/actions/endpoints/endpointsResource';
import { EndpointTypes } from 'src/models/Channels/endpointType';
import { getSettingsForType } from './helpers';
import ivrsResource from 'src/actions/ivrs/ivrsResource';
import { useResourceValue } from 'src/presentation/hooks/useDocumentResource';
import { useResourceValues } from 'src/presentation/hooks/useResource';

const useEntryPointType = (type: EndpointTypes) => {
  const { value: channelsConfiguration } = useResourceValue(channelsConfigurationResource);
  const { values: endpoints } = useResourceValues(endpointsResource);

  const { values: communicationQueues } = useResourceValues(communicationQueuesResource);
  const { values: accounts } = useResourceValues(accountsResource);
  const { values: ivrs } = useResourceValues(ivrsResource);

  const channelsConfig = channelsConfiguration[type];

  const endpointMap: Record<string, Endpoint[]> = groupBy(endpoints, 'id');

  return {
    config: getSettingsForType(type, {
      channelsConfig,
      communicationQueues,
      endpointMap,
      ivrs,
      accounts,
    }),
  };
};

export default useEntryPointType;
